module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADpSURBVHgBtVNREcIwDE13CJgDKmE4mAUUAA7AwRyAg4KS4gAJHQrAQUmu2V3I1q188O7edUmTl1yTAfwTMUaLdMhXTAhs25LkHScSL8gOeRVCzVJlwgNZT9wFFq5zAo6D7EKBLidA6k75SNAL21OHFUyDWnsq3xvZC5vu61VGgILX0mGM2agYuu+rifZdpgMZY/FokbdR8uzjpJiW3yN8TSGXzH4vzjiakE4WG+jFPgS2O135rCtz0FDpCHPgQKcqU8UIBRimMLz4nkktnkoEDLXJ33ck/SANztxAIaiDLaQNs5AW6AA/4AMzhDNS+/wVHAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/icon-password.png
// module id = JY4h
// module chunks = 0